import { useState, useContext } from 'react';
import { useForm, Resolver } from "react-hook-form"
import API from './API'
import { useNavigate } from "react-router-dom";
import { UserContext } from './UserContext';
import { ContextType } from './interfaces'
import ApiResult from './ApiResult';

type FormValues = {
    login: string
    password: string
}

const resolver: Resolver<FormValues> = async (values) => {
    return {
        values: values.login ? values : {},
        errors: !values.login
            ? {
                login: {
                    type: "required",
                    message: "This is required.",
                },
            }
            : {},
    }
}




function Login() {

    const navigate = useNavigate();
    const { setCurrentUser } = useContext(UserContext) as ContextType;
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string[] }>(null)
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit } = useForm<FormValues>({ resolver })
    const onSubmit = handleSubmit((data) => {
        setLoading(true);
        return API.getChallenge().then(async (response) => {
            const challenge = response.challenge;
            return await digestMessage(challenge + ':' + await digestMessage(data.login.toLowerCase() + ':' + data.password))
        }).then((response: string) => {
            return API.doLogin(data.login, response)
        }).then((data) => {
            console.log(data)
            setCurrentUser(data)
            setLoading(false);
            setApiResult(null)
            switch (data.adminLevel) {
                case 0:
                    navigate('/dashboard/month')
                    break;
                default:
                    navigate('/dashboard')
            }
        }).catch((err: any) => {
            console.log(err)
            setLoading(false);
            setApiResult(err)
        })

    })


    async function digestMessage(message: string) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        return hashHex;
    }


    return (
        <div className="container">
            <h1 className="h3 mb-3 fw-normal text-center">Synchronix - Prihlásenie</h1>

            <main className="form-signin d-flex justify-content-center">
                <form onSubmit={onSubmit}>

                    <div className="form-floating mt-2">
                        <input {...register("login")} type="login" className="form-control" id="floatingInput" placeholder="name@example.com" />
                        <label htmlFor="floatingInput">E-mailová addresa</label>
                    </div>
                    <div className="form-floating mt-2">
                        <input {...register("password")} type="password" className="form-control" id="floatingPassword" placeholder="Password" />
                        <label htmlFor="floatingPassword">Heslo</label>
                    </div>

                    <button disabled={loading} className="w-100 btn btn-lg btn-primary mt-2" type="submit">{loading ? 'Prihlasujem' : 'Prihlásiť'}</button>
                </form>
            </main>

            <ApiResult errorObject={apiResult} />
        </div>

    );
}

export default Login;
